<div class="row">
  <div class="col-lg-3 col-md-3 col-sm-12 category-card" *ngFor="let item of itemList">
    <div class="inner-content text-center">
      <div class="card-image">
        <img src={{item.image}} />
      </div>
      <h3>{{item.title}}</h3>
      <p>
        {{item.description}}
      </p>
    </div>
  </div>
</div>